// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../common/Components/IconV5.bs.js");
let Container = require("../common/Components/Container.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let TerminatedAgentSharedPropertyV5_sharedProperty_graphql = require("../../__generated__/TerminatedAgentSharedPropertyV5_sharedProperty_graphql.bs.js");

let convertFragment = TerminatedAgentSharedPropertyV5_sharedProperty_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, TerminatedAgentSharedPropertyV5_sharedProperty_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(TerminatedAgentSharedPropertyV5_sharedProperty_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, TerminatedAgentSharedPropertyV5_sharedProperty_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(TerminatedAgentSharedPropertyV5_sharedProperty_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function TerminatedAgentSharedPropertyV5(props) {
  let match = RescriptRelay_Fragment.useFragment(TerminatedAgentSharedPropertyV5_sharedProperty_graphql.node, convertFragment, props.terminatedAgentSharedProperty);
  let agentName = Stdlib_Option.getOr(Stdlib_Option.map(match.sender, x => x.displayName), "");
  return JsxRuntime.jsx(Container.make, {
    className: "mt-8",
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(IconV5.make, {
              icon: "attention-alt",
              size: 60,
              className: "text-tan-biscay"
            }),
            className: "pl-4 pr-6"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("h3", {
                  children: "This property is no longer shared",
                  className: "text-xl font-medium leading-6 text-gray-900"
                }),
                JsxRuntime.jsx("div", {
                  children: `The property cannot be viewed as your agent ` + agentName + ` no longer has an active TAN subscription.`
                })
              ],
              className: "mb-6 flex flex-col gap-4"
            })
          })
        ],
        className: "flex"
      }),
      className: "bg-white border p-5 rounded"
    })
  });
}

let make = TerminatedAgentSharedPropertyV5;

exports.Fragment = Fragment;
exports.make = make;
/* IconV5 Not a pure module */
